// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-copy-button[data-v-6a5e837e]{position:fixed;bottom:0;left:0;right:0;padding:1rem;background:#fff;border-top:1px solid #ddd;z-index:999;box-shadow:0 -2px 6px rgba(0,0,0,.1);transition:all .3s ease;display:flex;align-items:center;justify-content:center;gap:3rem}.fixed-copy-button.is-bottom[data-v-6a5e837e]{position:static;box-shadow:none;border-top:none;padding:0}.button-placeholder[data-v-6a5e837e]{height:80px}", ""]);
// Exports
module.exports = exports;
